import { render, staticRenderFns } from "./LidershipModal.vue?vue&type=template&id=55823d78&scoped=true&"
import script from "./LidershipModal.vue?vue&type=script&lang=js&"
export * from "./LidershipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55823d78",
  null
  
)

export default component.exports